export default {
  "operator": "Operator",
  "operateDate": "Operate Date",
  "informationConfirm": "Information Confirm",
  "animalModel": "Animal Model",
  "group": "Group",
  "export": "Export",
  "reportInfo": "Reported Information",
  "additionalData": "AdditionalData",
  "source": "Source",
  "recentlyUsed": "Recently used",
  "percentage": "Percentage",
  "needCages": "Need Cages",
  "nextWeekNum": "Animals are expected to be received next week",
  "thisWeekNum": "Animals are expected to be received this week",
  "company": "Company",
  "tenant": "Tenant",
  "costCenter": "Cost Center",
  "dict": "Dictionary",
  "input": "Input",
  "date": "Date",
  "time": "Time",
  "num": "Number",
  "file": "File",
  "delete": "Delete",
  "log": "Log",
  "fileName": "FileName",
  "uploadTime": "Upload Time",
  "uploadBy": "Upload By",
  "downloadTime": "Download Time",
  "downloadBy": "Download By",
  "close": "Terminate",
  "applyForModification": "Apply For Amendment",
  "applyForClose": "Apply For Terminate",
  "createdDate": "Created Date",
  "createdBy": "Created By",
  "review": "Review",
  "plan": "Plan",
  "createAmendment": "Create Amendment ",
  "viewLogs": "View Logs",
  "template": "Template",
  "attachment": "Attachment",
  "basicInfo": "Basic Information",
  "madeSomeChanges": "made some changes",
  "AddReminder": 'Add Reminder',

  "common": {
    "isRequired": "Is required",
    "type": "Type",
    "name": "Name",
    "numberRemaining": "Remaining Number",
    "remaining": "Remaining",
    "used": "Used",
    "total": "Total",
    "effectiveDuration": "Effective Duration",
    "day": "Days",
    "newWindow": "Open in new window",
    "user": "User",
    "ok": "OK",
    "error": "Error",
    "home": "1",
    "id": "ID",
    "site": "Site",
    "department": "Department",
    "comment": "Comment",
    "submit": "Submit",
    "location": "Location",
    "systemId": "System ID",
    "project": "Project",
    "receive": "Receive",
    "approve": "Approve",
    "reject": "Reject",
    "success": "Success",
    "cancel": "Cancel",
    "back": "Back",
    "active": "Active",
    "disabled": "Disabled",
    "expired": "Expired",
    "edit": "Edit",
    "update": "Update",
    "operate": "Admin Operate",
    "Operate": "Operate",
    "filter": "Filter",
    "clearFilter": "Clear Filter",
    "search": "Search",
    "searchBtn": "Search",
    "upload": "Upload",
    "download": "Download",
    exportRequest: 'Export Request Record',
    "print": "Print",
    "list": "List",
    "detail": "Detail",
    "new": "New",
    "save": "Save",
    "width": "Width",
    "length": "Length",
    "request": "Approvals",
    "Register": "New Item",
    "apply": "Request",
    "Attachment": "Attachment",
    "Denied": "Rejected",
    "already": "Approved",
    "GenerateStudyRecords": "Generate Study Records",
    "add": "Add",
    "unitPrice": "Unit Cost",
    "totalPrice": "Cost",
    "AutomaticallyBySys": "Automatically generated by the system after submission",
    "placeOfWork": "place of work",
    "background": "Background",
    "age": "Age",
    "order": "Order",
    "changeLog": 'Change Log',
    "myList": 'My List (including Draft)',
    "temporaryStorage": "Temporary Storage"
  },
  "AFMSystem": "AFMSystem",
  "route": {
    "attachDownloadLog": "附件下载记录",
    "饲养管理": "饲养管理",
    "物料列表": "物料列表",
    "物料申请列表": "物料申请列表",
    '物料领用管理': '物料领用管理',
    "动物及环境监测": "动物及环境监测",
    "仪器设备及报修": "仪器设备及报修",
    "动物房信息汇总": "动物房信息汇总",
    "实验人员信息": "实验人员信息",
    "仪器管理及预约": "仪器管理及预约",
    "AFMSystem": "AFMSystem",
    "poRequest": "PO & SAP",
    "poList": "PO",
    "po": "PO",
    "studyTemplate": "Study Template",
    "item": "Item",
    "mail": "Mail Test",
    "systemManagement": "System Management",
    "usage": "Usage Report",
    "study": "Study",
    "healthCheck": "Health Check",
    "cageCard": "Cage Card",
    "cageCardManage": "Print Template Manage",
    "protocol": "Protocol",
    "protocolList": "Protocol List",
    "request": "Request",
    "requestList": "Request List",
    "order": "Order",
    "orderList": "OrderList",
    "animalWelfare": "Animal welfare",
    "AnimalCare": "AnimalCare",
    "beastie": "beastie",
    "CorpseDisRecord": "CorpseDisRecord",
    "environment": "environment",
    "FeedBedding": "FeedBedding",
    "repairs": "repairs",
    "TemAndHumRecord": "TemAndHumRecord",
    "toProtocol": "IACUC",
    "orderAndFeed": "Order and raisie",

    "feedingManagementAndCageStats": "Feeding Management / Cage Stats",

    "feedingManagement": "Feeding Management",
    "feedingManagementDetail": "Feeding Management Detail",

    "cageChargingStandard": "Cage Charging Standard",
    "createFeedingRegister": "Create Feeding Register",
    "addInspectionRecords": "Add Inspection Records",
    'inspectionRecord': 'Inspection Record',

    "cageLocationPIStatistics": "Cage Charging Standard",
    "addCageLocationPIStatistics": "Add CageLocation PI Statistics",

    "orderRequestList": "Order Request",
    "biologicalPurificationList": "Biological Purification",
    "quarantineList": "Quarantine",
    "selfCarryList": "Self Carry",
    "animalInfoManageList": "Animal Information Manage",
    "subjectManagement": "Subject Management",
    "subjectList": "Subject List",
    "subjectEdit": "Subject Edit",
    "knowledge": "Knowledge",
    "knowledgeList": "Knowledge List",
    "knowledgeEdit": "Knowledge Edit",
    "examPaper": "ExamPaper",
    "examPaperList": "ExamPaper List",
    "ExamPaperCreate": "ExamPaper Edit",
    "question": "Question",
    "examQuestion": "Exam Question",
    "examQuestionList": "Exam Question List",
    "singleChoice": "Single Choice",
    "multipleChoice": "Multiple Choice",
    "trueFalse": "True False",
    "gapFilling": "Gap Filling",
    "shortAnswer": "Short Answer",
    "AnswerPage": "AnswerPage",
    "AnswerJudgePageList": "AnswerJudgePageList",
    "AnswerCompletePageList": "AnswerCompletePageList",
    "log": "Log",
    "logUserPage": "logUserPage",
    "answerCenter": "Answer Center",
    "examRecords": "Exam Records",
    "costsAndSettlement": "Costs And Settlement",
    "costStatisticsList": "Cost Statistics",
    "settlementStatisticsList": "Settlement Statistics",
    "rechargeAndRefundRecordList": "Recharge And Refund Record",
    "roomAndInstrument": "Room And Instrument Reservation",
    "instrumentList": "Instrument List",
    "instrumentBookedList": "Instrument Booked",
    "roomList": "Room List",
    "roomBookedList": "Room Booked List",
    "ItemCabinetBookedList": "ItemCabinet Booked List",
    "externalServices": "External Services",
    "offlineExamsAdmin": "OfflineExams Admin",
    "offlineExams": "OfflineExams",
    "offlineExamsList": "OfflineExams List",
    "examCenter": "Exam Center",
    "qualification": "Qualification",
    "applicationList": "My Access Applications",
    "applicationApply": "Submit Access Application",
    "applicationDetail": "Application Detail",
    "applicationAdmin": "Access Application Admin",
    "applicationAdminDetail": "Application Detail",
    "applicationExamDo": "Start Exam",
    "applicationJudge": "Grade Paper",
    "examApplicationList": "My Access Applications",
    "examApplicationApply": "Submit Access Application",
    "examApplicationDetail": "Application Detail",
    "examApplicationAdmin": "Access Application Admin",
    "examApplicationAdminDetail": "Application Detail",
    "onlineExams": "Online Exams",
    "animalRequest": '动物代购'
  },


  "order": {
    "containerType": "Container Type",
    "labelOfContainer": "Label of Container to be Read",
    "statusOfContainer": "Status of Container",
    "containerDisinfection": "Container Disinfection",
    "foodAvailable": "Food Available",
    "jellyGelAvailable": "Jelly Gel Available",
    "visualChecking": "Visual Checking on Animal Status",
    "checkingRecords": "Checking Records Supplied byVendor (if appropriate)",
    "checkBox": "Animal Receiving and Transport Container Status Checking",
    "requestYear": "Year",
    "returnToSubmit": "Return to submit",
    "roomAssigned": "Room Assigned",
    "applicationForm": "Application Form",
    "totalAmount": "Total Amount",
    "sameStudy": "Same Study Request",
    "sendTo": "Send To",
    "orderInformation": "Order Information",
    "orderBy": "Order By",
    "orderId": "Order ID",
    "order": "Order",
    "delivery": "Deliver",
    "orderDate": "Order Date",
    "newRequest": "New Request",
    "rejectRequest": "Reject Request",
    "status": "Status",
    "placeOrder": "Place Order",
    "request": "Request",
    "requestHistory": "Request History",
    "requestId": "Request ID",
    "requester": "Requester",
    "requestDate": "Request Date",
    "requestStatus": "Request Status",
    "department": "Department",
    "expectedDeliveryDate": "Expected Delivery Date",
    "requestInformation": "Request Information",
    "orderNumber": "Order Number",
    "requestNumber": "Number Of Requests",
    "orderNo": "Order No.",
    "requestNo": "Request No.",
    "referDoc": "大小鼠周龄体重关系（20201021）",
    "arrival": "Receive",
    "arrivalInformation": "Arrival Information",
    "arrivalBy": "Received By",
    "arrivalNo": "Received No.",
    "arrivalDate": "Received Date",
    "healthCert": "Health Certification",
    "quarantineCert": "Quarantine Certification",
    "guangdongCert": "广东省实验证明",
    "healthCertNo": "Health Cert No.",
    "healthCertNumber": "Health Certification Number",
    "arrivalRoom": "Received Room",
    "attachment": "Attachment （Animal quality certificate）",
    "completion": "Completion"
  },


  "protocol": {
    "submit": "Submit for review",
    "close": "Terminate Protocol",
    "newProtocol": "New Protocol",
    "newTemplate": "New Protocol Template",
    "status": "Protocol Status",
    "iacucNumber": "IACUC Number",
    "protocolInformation": "Protocol Information",
    "effectiveList": "Effective List",
    "expireList": "Inactive List",
    "protocolName": "Protocol Name",
    "studyDirector": "Study Director",
    "studyMonitor": "Study Monitor",
    "contributionScientists": "Contribution Scientists",
    "effectiveDate": "Effective Date",
    "expireDate": "Expire Date",
    "folderPath": "Folder Path",
    "animalInformation": "Animal Information",
    "numberApproved": "IACUC Number Approved",
    "total": "Total",
    "percentage": "Percentage",
    "iacucNo": "IACUC No",
    "numberRemaining": "IACUC Remaining No.",
    "numberUsed": "IACUC Used No.",
    "sendToCommittee": "Send To Committee",
    "committeeMembers": "Committee Members",
    "committeeApproveComment": "Committee Comment",
    "committeeApprove": "Committee Approve",
    "primaryApproveComment": "Primary Comment",
    "primaryApprove": "Primary Approve",
    "return": "Return",
    "IACUCProtocol": "The Protocol IACUC Number ",
    "IACUCProtocol2": " will be expired on ",
    "IACUCProtocol3": ". Please request a new protocol asap."
  },

  "healthCheck": {
    "closeDate": "Close Date",
    "closeBy": "Close By",
    "euthanasiaMethod": "Method of Euthanasia",
    "caseStatus": "Case Status",
    "caseResults": "Case Results",
    "caseNumber": "Case No.",
    "caseId": "Case Id",
    "close": "Case close",
    "healthCare": "Veterinarian Health Care",
    "healthCheck": "Health Check",
    "checkType": "Checked Type",
    "clinicalSign": "Clinical Sign",
    "clinicalSignType": "Clinical Sign Type",
    "checkBy": "Reported By",

    "checkDate": "Test Date",
    "checkNumber": "Checked No.",
    "checkOption": "Check Option",
    "checkStage": "Check Stage",
    "checkItem": "Check Item",
    "samplingDate": "Sampling Date",
    "samplingSite": "Sampling Site",
    "sampleSize": "Sample Size",
    "values": "Values (number of colonies)",
    "criterion": "Criterion",
    "results": "Results",
    "materialName": "Material Name",
    "materialManufacturer": "Material Manufacturer",
    "lot": "Lot",
    "sampleNumber": "Sample No.",
    "area": "Area",
    "lab": "Lab",
    "sampleType": "Sample Type",
    "checkMode": "Check Mode",
    "sampleName": "Sample Name",
    "sterilizationDate": "Sterilization Date",
    "opreation": "Opreation"
  },

  "study": {
    "studyNumber": "Study Number",
    "studyNo": "Study No",
    "studyDirector": "Study Director",
    "taskSegment": "Task Segment",
    "giftQuantity": "Gift Quantity",
    "diseaseType": "Disease type",
    "projectType": "Project Type"
  },

  "animal": {
    "animalInformation": "Animal Information",
    "vendor": "Vendor",
    "strain": "Strain",
    "species": "Species",
    "gender": "Gender",
    "animalCode": "Animal Code",
    "weight": "Weight",
    "bodyWeight": "Body Weight",
    "age": "Age",
    "room": "Room",
    "gene": "Gene",
    "arrivalNo": "Received No",
    "arrivalNumber": "Received Number",
    "arrivalAge": "Age at Received",
    "arrivalRoom": "Received Room",
    "rackNo": "Rack No."

  },

  "welfare": {
    "list": "benefits List",
    "Registration": "Registration",
    "ItemApplyFor": "Item Apply for",
    "ApplicationRecord": "Application record",
    "Out-of-stockReminders": "Out-of-stock reminders",
    "download": "download"
  },


  "message": {
    "form": {
      "notFinish": "There are some required field in the form that have not been filled in",
      "requiredField": "This field is required !",
      "maxField": "This field max length !"
    },
    "enterToSearch": "Enter the content and press enter to search",
    "confirmRequestToSap": "Po remaining quantity is insufficient. Continue?",
    "expectedDelivery": "The expected delivery date is",
    "confirm": "Please confirm before action",
    "roomNoAddInfo": "The feeding room lacks necessary information, please contact the administrator to add",
    "confirmRefreshRequest": "This operation will affect historical data. Do you want to continue?",
    "findDraftProtocol": "Unfinished protocol found. Are you sure you want to continue creating new protocol",
    "closeProtocol": "Are you sure you want to terminate this protocol ?",
    "sendEmailSuccess": "Send email success",
    "studyOtherRequest": "Please note that there are other animal requests for the study",
    "remainingNumNotEnough": "IACUC remaining number is 0, please change IACUC or species",
    "selectIACUCFirst": "Please select IACUC first",
    "rejectRequest": "Rejected animal request ",
    "arrivalNumCheck": "Arrival Number cannot be less than 1 ",
    "requestNumCheck": "Request Number cannot be less than 1 ",
    "requestRemainingCheck": "Request Number cannot be greater than  Remaining Number",
    "confirmDelete": "Are you sure you want to delete this?",
    "deleteSuccess": "Delete Success",
    "contextIsNull": "Content cannot be empty",
    "notSelect": "Select at least one piece of data",
    "mustBeSubmit": "Status must be submit !",
    "selectReuquest": "Select Reuquest First !",
    "updateSuccess": " update successfully!",
    "printSuccess": "Printing information has been sent, please go to the printer to check",
    "confirmCancel": "Are you sure you want to leave the current page?",
    "confirmReject": "Are you sure you want to reject this request?",
    "confirmReceive": "Are you sure you want to receive animals",
    "confirmApprove": "Are you sure you  to approve?",
    "confirmReturnToSubmit": "Are you sure you want to return this request to submit status?",
    "confirmAction": " Please confirm before action",
    "roomIs": "The room is ",
    "selectEffectiveDateFirst": "Select effectiveDate first",
    "cancelOrder": "Are you sure you want to cancel order",
    "cancelOrderSuccess": "The order has been cancelled",
    "success": "reuquest success",
    "saveSuccess": "saved successfully",
    "unsavedToLeave": "Do you still have any unsaved items to leave",
    "dateEarl": "The delivery date cannot be earlier than the request date",
    "roomAssigned": "Please select a room"
  },

  "filter": {
    "equal": "Equal",
    "notEqual": "Not Equal",
    "in": "In",
    "like": "Like",
    "greaterThan": "Greater Than",
    "lessThan": "Less Than"
  },

  "print": {
    "template": "PrintTemplate",
    "templateName": "Template Name",
    "printNumber": "Print Number",
    // "quarantineNumber": "Quarantine Number",
    // "project": "project",
    // "strain": "Strain",
    // "studyDirector": "Study Director",
    // "studyNumber": "Study Number",
    // "weight": "Weight",
    // "RequestNumber": "Request Number"
  },

  "sap": {
    "contractNumber": "Contract Number",
    "vendorCode": "Vendor Code",
    "companyCode": "Company Code",
    "price": "Price （CNY）",
    "costCenter": "Cost Center",
    "staffCode": "Staff Code",
    "wbs": "WBS Element"

  },

  "po": {
    "number": "PO No.",
    "refreshRequest": "Refresh Request",
    "downloadRequest": "Download Request"
  },
  "facilities": {
    "feedBedding": "Feed bedding",
    "environmental": "Environmental Monitoring Report",
    "corpse": "Corpse disposal record",
    "veterinary": "Animal care - Veterinary",
    "instrument": "Instrument and equipment management",
    "personnel": "Personnel information management",
    "detection": "Detection of diet and drinking water"
  },

  "orderAndFeed": {
    "newOrderApplication": "Newly submitted animal order",
    "ordersToBeReceived": "Animal orders to be received",
    "totalOrdersMonth": "Total orders for this month",
    "totalOrderAmount": "Total amount for this month",
    "experimenterInfo": "Experimeter",
    "raisingRoom": "Raising Room",
    "environment": "Environment",
    "breedingComment": "Breeding Comment",
    "appComTime": "Request/Receive Date",
    "group": "Research Group",
    "groupName": "Tenant Name",
    "mail": "Email",
    "phone": "phone",
    "requestNumber": "Request Number",
    "expectDeliveryDate": "Expect Delivery Date",
    "inventoryStatus": "Inventory Status",
    "deliveryTime": "Delivery time",
    "addPurchase": "Add purchase",
    "feedingRequest": "Raising Request",
    "feedingFloor": "Raising Floor",
    "envRequirements": "Environmental Requirements",
    "raisingComment": "Raising Comments",
    "orderComment": "Order Comment",
    "quarantineExpenses": "Quarantine expenses",
    "quarantineInfo": "Quarantine Information",
    "animalDeliveryate": "The animal delivery date must be one week in advance, and must be delivered before 3pm on the day of delivery, otherwise it will not be accepted",
    "purifyInfo": "Purify Information",
    "allele": "Allele",
    "weeksOfAge": "Week(weeks)",
    "SelfPurchasedAniInfo": "Self purchased animal  information",
    "animalOrigin": "Animal origin",
    "purificationExpenses": "Purification Expenses",
    "experimenter": "Experimenter",
    "researchGroup": "Research Group",
    "completionTime": "Completion Time",
    "animalGrade": "Grade of animal",
    "takeItAway": "Take it or not",
    "PIApproved": "PI Approved",
    "PINotApproved": "PI NotApproved",
    "ordering": "Ordering",
    "orderReceive": "Order Receive",
    "completeBP": "Complete Biological Purification",
    "completeQuarantine": "Complete Quarantine",
    "complete": "Complete",
    "Age/Weight": "Age/Weight",
    "orderLimit": "Order Limit/Day",
    "orderableStatus": "Orderable status",
    "associatedOrderNumber": "Associated order number",
    "requestType": "Request Type",
    "status": "Status",
    "amount": "Amount",
    "animalOrderingInfo": "Animal ordering information",
    "animalReceptionInfo": "Animal reception information",
    "genotype": "Genotype",
    "selectIACUC": "Please select IACUC No.",
    "animalNumber": "Animal Number",
    "quarantineNumber": "Quarantine Number"
  },

  "costsAndSettlement": {
    "bankAccount": "BankAccount",
    "exportDetails": "Export Details",
    "exportGeneralTable": "Export General Table",
    "animalRequest": "Animal Request",
    "bPurification": "Biological Purification",
    "quarantine": "Quarantine",
    "animalRaising": "Animal Raising",
    "instrumentation": "Instrumentation",
    "materialRequisition": "Material Requisition",
    "manualDeduction": "Manual Deduction",
    "totalCost": "合计费用",
    "settlementCost": "Settlement Cost",
    "total": "Total",
    "balance": "Balance",
    "HeadResearchGroup": "Head of the research group",
    "start-stopDate": "Start-stop date",
    "settlementNumber": "settlement No.",
    "SettlementMethod": "Settlement Method",
    "appUpDate": "Application/Update Date",
    "rechargeAmount": "Recharge Amount",
    "refundAmount": "Refund Amount",
    "rechargeRefundMethod": "Recharge/RefundMethod"
  },

  "form": {
    "Species": "Species",
    "Strain": "Strain",
    "Weight": "Weight",
    "Age": "Age",
    "Weight/Age": "Weight/Age",
    "Gender": "Gender",
    "Class": "Class",
    "Vendor": "Vendor",
    "Comments": "Comments"
  },

  announcement: {
    name: 'Announcement',
    add: 'Add Announcement',
    title: 'Announcement Title',
    content: 'Announcement Content',
    notificationObjects: 'Notification Objects',
    releaseTime: 'Created At',
    createdBy: 'Created By',
    status: 'Status',
    releaseMsg: 'Whether to push a message',
    wholeMembers: 'Whole Members',
    tenement: 'Tenement',
    category: 'Category',
    draft: 'Draft',
    release: 'Release',
    removed: 'Removed',
    remove: 'Remove'
  },

  changeLog: {
    animalRequest: 'Animal Request',
    changeType: 'Change Type',
    changeTime: 'Change Time',
    changeBy: 'Change By',
    changeFieldName: 'Change Field Name',
    previousValue: 'Previous Value',
    newValue: 'New Value',
    delete: 'Delete',
    update: 'Update',
    insert: 'Insert',
    reorder: 'Reorder',
    visibleMode: 'Default',
    hiddenMode: 'Show Hide'
  },

  payment: {
    costType: 'Cost Type',
    foreignKey: 'Business ID',
    operator: 'Operator',
    paymentTime: 'Payment Time',
    finalAmount: 'Final Amount',
    preAmount: 'Pre Amount',
    postAmount: 'Post Amount'
  },

  fileManagement: {
    TransferToFileManagement: 'Transfer to INDFiles'
  },

  "cardboard": "Cardboard",
  "plastic": "Plastic",
  "metalMesh": "Metal Mesh",
  "others": "Others",
  "y": "Y",
  "n": "N",
  "normal": "Normal",
  "brokenContainer": "Broken Container",
  "foundDead": "Found Dead",
  "abnormalityVisualChecking": "Abnormality of Visual Checking"

}
